import { useState } from "react";
import { useTranslation } from "react-i18next";

const SocialFloating = () => {
  const [hovered, setHovered] = useState<string | null>(null);
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const waMsg = lang === "es"
    ? "¡Hola! Me gustaría obtener más información sobre sus servicios de limpieza y reparaciones. ¿Pueden ayudarme?"
    : "Hello! I'd like to get more information about your cleaning and handyman services. Can you help me?";

  const directionsLabel = lang === "es" ? "Cómo llegar" : "Get Directions";

  const socials = [
    {
      id: "whatsapp",
      icon: "ri-whatsapp-line",
      label: "WhatsApp",
      href: `https://wa.me/15612626118?text=${encodeURIComponent(waMsg)}`,
      glow: "rgba(37,211,102,0.5)",
      bg: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
      arrowColor: "#128C7E",
    },
    {
      id: "facebook",
      icon: "ri-facebook-fill",
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61576446373257",
      glow: "rgba(24,119,242,0.5)",
      bg: "linear-gradient(135deg, #1877F2 0%, #0a4fa8 100%)",
      arrowColor: "#0a4fa8",
    },
    {
      id: "google",
      icon: "ri-map-pin-2-fill",
      label: directionsLabel,
      href: "https://www.google.com/maps/search/Adry+Cleaning+and+Handyman+Service/@26.7153,-80.0534,15z",
      glow: "rgba(234,67,53,0.4)",
      bg: "linear-gradient(135deg, #EA4335 0%, #FBBC05 50%, #34A853 100%)",
      arrowColor: "#34A853",
    },
    {
      id: "instagram",
      icon: "ri-instagram-line",
      label: "Instagram",
      href: "https://www.instagram.com/adrycleaningservice",
      glow: "rgba(225,48,108,0.5)",
      bg: "linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
      arrowColor: "#bc1888",
    },
  ];

  return (
    <>
      <style>{`
        @keyframes pulse-ring {
          0% { transform: scale(1); opacity: 0.7; }
          100% { transform: scale(1.7); opacity: 0; }
        }
        @keyframes float-up {
          0% { transform: translateY(6px); }
          50% { transform: translateY(-3px); }
          100% { transform: translateY(6px); }
        }
        .social-float-btn { animation: float-up 3s ease-in-out infinite; }
        .social-float-btn:nth-child(1) { animation-delay: 0s; }
        .social-float-btn:nth-child(2) { animation-delay: 0.4s; }
        .social-float-btn:nth-child(3) { animation-delay: 0.8s; }
        .social-float-btn:nth-child(4) { animation-delay: 1.2s; }
        .pulse-ring-anim { animation: pulse-ring 2s ease-out infinite; }
      `}</style>

      <div className="fixed bottom-24 right-5 z-50 flex flex-col items-center gap-4">
        {socials.map((s) => (
          <div key={s.id} className="social-float-btn relative flex items-center group">

            {/* Tooltip */}
            <div
              className="absolute right-16 px-3 py-1.5 rounded-full text-white text-xs font-heading font-semibold whitespace-nowrap pointer-events-none transition-all duration-200"
              style={{
                background: s.bg,
                boxShadow: `0 4px 14px ${s.glow}`,
                opacity: hovered === s.id ? 1 : 0,
                transform: hovered === s.id ? "translateX(0)" : "translateX(8px)",
              }}
            >
              {s.label}
              <span
                className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0"
                style={{
                  borderTop: "5px solid transparent",
                  borderBottom: "5px solid transparent",
                  borderLeft: "6px solid",
                  borderLeftColor: s.arrowColor,
                }}
              />
            </div>

            {/* Pulse ring */}
            <div
              className="pulse-ring-anim absolute inset-0 rounded-full pointer-events-none"
              style={{ background: s.glow }}
            />

            {/* Button */}
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHovered(s.id)}
              onMouseLeave={() => setHovered(null)}
              aria-label={s.label}
              className="relative w-12 h-12 flex items-center justify-center rounded-full cursor-pointer"
              style={{
                background: s.bg,
                boxShadow: hovered === s.id
                  ? `0 0 0 4px ${s.glow}, 0 8px 28px ${s.glow}`
                  : `0 4px 16px ${s.glow}`,
                transform: hovered === s.id ? "scale(1.2)" : "scale(1)",
                transition: "all 0.3s cubic-bezier(0.34,1.56,0.64,1)",
              }}
            >
              <i className={`${s.icon} text-white text-xl`}></i>
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default SocialFloating;
